import staticAssetsMap from './staticAssets/staticAssets.json';

export { staticAssetsMap };
